import React, { useState, useEffect, useRef } from "react";
import { InlineLoading, Dropdown } from 'carbon-components-react';
import { CaretDown32, CaretUp32 } from '@carbon/icons-react';
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import callPostApi from "../../requests/PostRequests";
import * as Constants from '../../requests/URLConstants';
import axios from "axios";
import moment from 'moment';

const DashboardSummary = (props) => {

    const [summaryData, setSummaryData] = useState([]);
    const [redAlertsCount, setRedAlertsCount] = useState(0);
    const [yellowAlertsCount, setYellowAlertsCount] = useState(0);
    const [SummaryLoader, setSummaryLoader] = useState(true);
    const [SummaryAlertsLoader, setSummaryAlertsLoader] = useState(true);
    const SalesOrderBookedImpact = useRef(0);
    const SalesOrderIntakeImpact = useRef(0);

    useEffect(() => {
        if (props.alerts && props.alerts.length > 0) {
            BPMNSummaryAlertsData(props.alerts, props.alertType);
        }
    }, [props.alerts, props.alertType]);

    useEffect(() => {
        console.log(props.impactArray && props.impactArray.length > 0)
        SalesOrderBookedImpact.current = 0;
        SalesOrderIntakeImpact.current = 0;
        if (props.impactArray) {
            for (var i = 0; i < props.impactArray.length; i++) {
                if (props.impactArray[i].ImpactedKPI === "Revenue Booked Sales Orders / day") {
                    SalesOrderBookedImpact.current = props.impactArray[i].Impact ? props.impactArray[i].Impact.toFixed(2) : 0;
                }
                if (props.impactArray[i].ImpactedKPI === "Sales Orders Intake / day") {
                    SalesOrderIntakeImpact.current = props.impactArray[i].Impact ? props.impactArray[i].Impact.toFixed(2) : 0;
                }
            }
            BPMNSummaryData();
        }
    }, [props.impactArray, SalesOrderBookedImpact, SalesOrderIntakeImpact])

    const getSummaryData = (SalesOrderBookedValue, SalesOrderBookedDelta, SalesOrderIntakeValue, SalesOrderIntakeDelta) => {
        let summary = [
            {
                title: DashboardConstants.SalesOrdersRevenue,
                value: SalesOrderBookedValue,
                target: SalesOrderBookedDelta + "%",
                impact: SalesOrderBookedImpact.current ? SalesOrderBookedImpact.current : 0
            },
            {
                title: DashboardConstants.SalesOrdersIntake,
                value: SalesOrderIntakeValue,
                target: SalesOrderIntakeDelta + "%",
                impact: SalesOrderIntakeImpact.current ? SalesOrderIntakeImpact.current : 0
            }
        ]
        setSummaryData(summary);
    };

    const prepareDailyThroughputForSingleKPI = (response) => {
        let LatestValue, OldValue;
        let Delta;
        let buckets = [];
        if (response.body) {
            buckets = response.body.aggregations.daily_SMD.buckets;
            LatestValue = buckets[0].daily_SMD_max.value ? buckets[0].daily_SMD_max.value : 0;
            OldValue = buckets[1] && buckets[1].daily_SMD_max.value ? buckets[1].daily_SMD_max.value : 0;
            Delta = isNaN(parseFloat(((LatestValue - OldValue) / OldValue) * 100).toFixed(2)) || OldValue === 0 ? 0 : parseFloat(((LatestValue - OldValue) / OldValue) * 100).toFixed(2);
        }
        props.setSalesOrderBookedValue(LatestValue);
        return { LatestValue, Delta }
    }

    const prepareDailyThroughputMetric = (response) => {
        let LatestValue, OldValue;
        let Delta;
        let buckets = [];
        if (response.body) {
            buckets = response.body.aggregations.daily_SMD.buckets;
            LatestValue = buckets[0].daily_SMD_max.value ? buckets[0].daily_SMD_max.value : 0;
            OldValue = buckets[1] && buckets[1].daily_SMD_max.value ? buckets[1].daily_SMD_max.value : 0;
            Delta = isNaN(parseFloat(((LatestValue - OldValue) / OldValue) * 100).toFixed(2)) || OldValue === 0 ? 0 : parseFloat(((LatestValue - OldValue) / OldValue) * 100).toFixed(2);
        }
        props.setSalesOrderIntakeValue(LatestValue);
        return { LatestValue, Delta }
    }

    const BPMNSummaryData = () => {
        let formattedData = []; let formattedData2 = [];
        setSummaryLoader(true)
        let timeZone = moment.tz.guess();
        let bodyJSON = {
            "interval": {
                "time_zone": timeZone
            },
            "processName": props.SummaryDropdown,
            "daysFromToday": moment().diff(props.timeFilterSelections.startDate, "days") === 0 ? 0 : moment().diff(props.timeFilterSelections.startDate, "days") //(Todays date - Start date)
        }
        axios.all([callPostApi(Constants.GETDAILYTHROUGHPUTFORSINGLEKPI, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response1 => {
            return response1;
        }),
        callPostApi(Constants.GETDAILYTHROUGHPUTMETRIC, {
            'Content-Type': 'application/json'
        }, bodyJSON).then(response2 => {
            if (response2.body) {
                return response2;
            }
        })]).then(axios.spread((response1, response2) => {
            setSummaryLoader(false)
            formattedData = prepareDailyThroughputForSingleKPI(response1);
            formattedData2 = prepareDailyThroughputMetric(response2)
            props.SummaryDropdown !== 'FinanceReporting' && getSummaryData(formattedData.LatestValue, formattedData.Delta, formattedData2.LatestValue, formattedData2.Delta)
        })).catch((error) => {
            setSummaryLoader(false)
        });
    }

    const BPMNSummaryAlertsData = (alerts, alertType) => {
        setSummaryAlertsLoader(true);
        if (alertType === 'application') {
            setRedAlertsCount(alerts.length);
        } else {
            setYellowAlertsCount(alerts.length);
        }
        setSummaryAlertsLoader(false);

    }

    return (
        <div className="dashboard-summary col-lg-12 no-gutters">
            <div className="summary-wrapper col-lg-2">
                <div className="title">
                    {DashboardConstants.Summary}
                </div>
                <div className="dashboard-title">
                    {DashboardConstants.Bpmn}
                </div>
            </div>
            <div className="tile-container col-lg-10">
                {props.SummaryDropdown !== 'FinanceReporting' ?
                    SummaryLoader ?
                        <div className="tile loading-container">
                            <InlineLoading
                                description={DashboardConstants.Loading}
                            />
                        </div>
                        :
                        summaryData && summaryData.length ?

                            <div style={{ display: 'flex', columnGap: "50px", rowGap: "5px", flexWrap: "wrap" }}>{
                                summaryData.map((type, index) => (

                                    <div className="tiles" key={index}>
                                        <div className="tiles-upper-div">
                                            <div className="tile-sub-title">{DashboardConstants.Actual}</div>
                                            <div className="tile-value carbon-display-Light-48">
                                                {typeof type.value === 'number' ? Math.round(type.value || 0) : type.value}
                                            </div>
                                            <div className="tile-sub-title">
                                                {DashboardConstants.Impact}</div>
                                            <div className="impact">{type.impact}</div>

                                            <div className={((type.target.toString().includes('%') ? type.target.substring(0, type.target.length - 1) : type.target)) < 0 ? "statusIndicator red" : "statusIndicator green"} >
                                                {((type.target.toString().includes('%') ? type.target.substring(0, type.target.length - 1) : type.target)) < 0 ? <CaretDown32 /> : <CaretUp32 />}
                                                {type.target} {DashboardConstants.SinceYesterday}
                                            </div>
                                        </div>
                                        <div className="tile-title">
                                            {type.title}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :
                            <div style={{ margin: "50px" }}>
                                {DashboardConstants.NoDataAvailable}
                            </div>
                    :
                    SummaryAlertsLoader ?
                        <div className="tile loading-container">
                            <InlineLoading
                                description={DashboardConstants.Loading}
                            />
                        </div>
                        :
                        props.SummaryDropdown === 'FinanceReporting' &&
                        <div className="alert-container">
                            <div className="title">{DashboardConstants.Alerts}</div>
                            <div className="key-container">
                                <div className="key-value horizontal-line"> <div className="key">{redAlertsCount}</div>
                                    <div className="value">{DashboardConstants.ApplicationAlerts}</div> </div>
                                <div className="key-value">  <div className="key">{yellowAlertsCount}</div>
                                    <div className="value">{DashboardConstants.SystemAlerts}</div> </div>
                            </div>
                        </div>
                }
            </div>
        </div >
    );
};

export default DashboardSummary;
